import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var CoinsStacked03 = function CoinsStacked03(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M13 5c0 1.1046-2.4624 2-5.5 2S2 6.1046 2 5m11 0c0-1.1046-2.4624-2-5.5-2S2 3.8954 2 5m11 0v1.5M2 5v12c0 1.1046 2.4624 2 5.5 2m0-8q-.2528 0-.5-.0082C4.1967 10.9 2 10.0433 2 9m5.5 6C4.4624 15 2 14.1046 2 13m20-1.5c0 1.1046-2.4624 2-5.5 2s-5.5-.8954-5.5-2m11 0c0-1.1046-2.4624-2-5.5-2s-5.5.8954-5.5 2m11 0V19c0 1.1046-2.4624 2-5.5 2s-5.5-.8954-5.5-2v-7.5m11 3.75c0 1.1046-2.4624 2-5.5 2s-5.5-.8954-5.5-2"
    })
  }));
};
export default CoinsStacked03;